<template>
    <b-modal
        id="checkoutModal"
        v-model="show"
        :size="inputs.length === 1 ? 'lg' : 'xl'"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="dark"
        body-bg-variant="dark"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideTempModal');onHide($event)"
    >

        <div class="modal-body custom-modal-class">
            <div class="close-button" @click="$emit('hideTempModal')">X</div>
            <div class="full-width" style="overflow-x: hidden">
                <div class="modal-header align-left">
                    <h2 class="m-0">Te rugăm completează câmpurile:</h2>
                </div>

                <validation-observer #default="{ invalid }" ref="observer">
                    <span class="display-none">{{ invalid }}</span>
                    <b-form class="mb-3 mt-2 custom-inner-wrapper">
                        <div class="flex justify-between" style="flex-direction: column">
                            <validation-provider
                                v-if="showAddress"
                                #default="{ errors }"
                                rules="required"
                                name="address"
                                class="form-wrapper"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-sm="3"
                                    label-cols-lg="3"
                                    class="custom-field-class"
                                    content-cols-sm
                                    content-cols-lg="9"
                                    label="Adresa"
                                >
                                    <b-form-input
                                        id="address"
                                        v-model="address"
                                        type="text"
                                        name="address"
                                        :state="errors.length > 0 ? false : null"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                v-if="showCity"
                                #default="{ errors }"
                                rules="required"
                                name="city"
                                class="form-wrapper"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-sm="3"
                                    label-cols-lg="3"
                                    class="custom-field-class"
                                    content-cols-sm
                                    content-cols-lg="9"
                                    label="Localitate"
                                >
                                    <b-form-input
                                        id="city"
                                        v-model="city"
                                        type="text"
                                        name="city"
                                        :state="errors.length > 0 ? false : null"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                v-if="showName"
                                #default="{ errors }"
                                rules="required"
                                name="name"
                                class="form-wrapper"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-sm="3"
                                    label-cols-lg="3"
                                    class="custom-field-class"
                                    content-cols-sm
                                    content-cols-lg="9"
                                    label="Numele companiei"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="name"
                                        type="text"
                                        name="name"
                                        :state="errors.length > 0 ? false : null"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                v-if="showState"
                                #default="{ errors }"
                                rules="required"
                                name="state"
                                class="form-wrapper"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-sm="3"
                                    label-cols-lg="3"
                                    class="custom-field-class"
                                    content-cols-sm
                                    content-cols-lg="9"
                                    label="Județ"
                                >
                                    <b-form-input
                                        id="state"
                                        v-model="state"
                                        type="text"
                                        name="state"
                                        :state="errors.length > 0 ? false : null"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                v-if="showRegNo"
                                #default="{ errors }"
                                rules="required"
                                name="reg_no"
                                class="form-wrapper"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-sm="3"
                                    label-cols-lg="3"
                                    class="custom-field-class"
                                    content-cols-sm
                                    content-cols-lg="9"
                                    label="Număr registrul comerțului"
                                >
                                    <b-form-input
                                        id="reg_no"
                                        v-model="reg_no"
                                        type="text"
                                        name="reg_no"
                                        :state="errors.length > 0 ? false : null"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                        </div>
                        <div style="color: white; text-align: center; cursor: pointer; border-radius: 5px; border: 2px solid white; width: 120px; float: right"
                             @click="submit()"
                        >Salvează</div>
                    </b-form>
                </validation-observer>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {
        BModal,
        BForm,
        BFormGroup,
        BFormInput,
        BButton,
        BIconTrash,
        BFormTextarea,
        BFormFile,
        BIconUpload,
        BFormSelect,
        BFormDatepicker
    } from 'bootstrap-vue';
    import {ValidationProvider, ValidationObserver} from 'vee-validate'
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn'
    require('@/helpers/validations/validations')
    export default {
        components: {
            BModal,
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            BIconTrash,
            BFormTextarea,
            BFormFile,
            BIconUpload,
            BFormSelect,
            BFormDatepicker,
            M3Warn,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            inputs: {
                type: Array,
                default: null,
            },
            showModal: {
                type: Boolean,
                default: null,
            }
        },
        data() {
            return {
                showAddress: false,
                showName: false,
                showState: false,
                showCity: false,
                showRegNo: false,
                address: null,
                name: null,
                city: null,
                state: null,
                reg_no: null,
                show: false,
            };
        },
        computed: {
            getInputs() {
                return this.inputs;
            }
        },
        watch: {
            getInputs: {
                handler: function () {
                    this.showAddress = false;
                    this.showName = false;
                    this.showState = false;
                    this.showCity = false;
                    this.showRegNo = false;
                    this.address = null;
                    this.name = null;
                    this.city = null;
                    this.state = null;
                    this.reg_no = null;

                    if(this.getInputs){
                        this.getInputs.forEach(input => {
                            if(input === 'address')
                                this.showAddress = true;

                            if(input === 'name')
                                this.showName = true;

                            if(input === 'state')
                                this.showState = true;

                            if(input === 'city')
                                this.showCity = true;

                            if(input === 'reg_no')
                                this.showRegNo = true;
                        })
                    }
                },
                deep: true,
                immediate: true
            },
            showModal: {
                handler: function() {
                    this.show = this.showModal
                },
                immediate: true
            }
        },
        mounted() {
            if(this.getInputs){
                this.getInputs.forEach(input => {
                    if(input === 'address')
                        this.showAddress = true;

                    if(input === 'name')
                        this.showName = true;

                    if(input === 'state')
                        this.showState = true;

                    if(input === 'city')
                        this.showCity = true;

                    if(input === 'reg_no')
                        this.showRegNo = true;
                })
            }
        },
        methods: {
            onHide(evt) {
                if ( evt && evt.trigger === "backdrop") {
                    evt.preventDefault();
                    this.$emit('hideTempModal')
                }
            },
            submit() {
                this.$refs.observer.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {

                        let savedForm = [];

                        this.getInputs.forEach(input => {
                            if(input === 'address')
                                savedForm.push({
                                    address: this.address
                                })
                            if(input === 'name')
                                savedForm.push({
                                    name: this.name
                                })

                            if(input === 'state')
                                savedForm.push({
                                    state: this.state
                                })

                            if(input === 'city')
                                savedForm.push({
                                    city: this.city
                                })

                            if(input === 'reg_no')
                                savedForm.push({
                                    reg_no: this.reg_no
                                })
                        })

                        this.$emit('savedForm', savedForm);
                        this.$emit('hideTempModal');
                    }
                })
            }
        },
    };
</script>

<style scoped>
.full-width {
    width: 100%;
}
.text-danger{
    position: absolute;
}
.modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.modal-body >>> .modal-header span {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}
.flex{
    display: flex;
}
.justify-between{
    justify-content: space-between;
}
.items-center{
    align-items: center;
}
.flex-start{
    align-items: flex-start;
}
.flex-column{
    flex-direction: column;
    display: flex;
}
.close-button {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 11px;
    line-height: 1;
    font-weight: 600;
    color: #000;
    background: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
a{
    font-size: 12px;
    text-align: right;
}
.modal-body p, .modal-body a {
    color: #fff;
}
form {
    margin-top: 30px !important;
}
.modal-body >>> .modal-header span {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}
.modal-header h2 {
    font-size: 31px;
    color: #fff;
    font-weight: 600;
}

.modal-header h3 {
    font-size: 16px;
    color: #fff;
    font-weight: 600;
    margin: 25px 0;
}
.red-text{
    color: var(--dangerColor);
}

.form-group >>> legend{
    font-size: 14px;
    min-width: 190px;
    max-width: 190px;
    opacity: 0.7;
    margin: 0;
    padding: 5px;
    color: #fff;
}
.form-group >>> .form-row{
    margin-bottom: 2.5px;
    flex-wrap: nowrap;
}
.form-group >>> input{
    font-size: 12px;
    color: #fff;
    background: transparent;
    border-color: #fff;
}
.imm-select >>> select{
    font-size: 12px;
    width: 190px;
    color: #fff;
    background: transparent;
    border-color: #fff;
    margin-bottom: 0;
}
.datepicker >>> .b-form-datepicker{
    background: transparent;
    font-size: 12px;
    color: #fff;
    border-color: #fff;
    max-width: 190px;
    margin-bottom: 0;
}
.b-form-datepicker >>> label, .b-form-datepicker >>> svg{
    color: #fff !important;
}
.b-form-datepicker >>> label{
    display: flex;
    align-items: center;
}
.imm-select >>> option{
    color: #000;
}
.form-control.is-invalid{
    border-color: #dc3545 !important;
}
.form-group >>> input::placeholder{
    font-size: 12px;
    color: #fff;
}
.form-group >>> textarea::placeholder{
    font-size: 12px;
    color: #fff;
}
.form-group >>> textarea{
    font-size: 12px;
    color: #fff;
    background: transparent;
    border-color: #fff;
}
.button-green-smaller{
    background: linear-gradient(to bottom, #36ad8c, #2b9477);
    color: #fff;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 9px 0;
    width: 100%;
    margin-top: 30px;
    max-width: 230px;
    min-height: 45px;
    border-radius: 4px;
    cursor: pointer;
    transition: 0.3s;
}
.button-red-smaller{
    background: linear-gradient(to bottom, #ff7070, #e05e5e);
    color: #fff;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.6;
    text-align: center;
    padding: 9px 0;
    width: 100%;
    margin-top: 30px;
    max-width: 230px;
    min-height: 45px;
    border-radius: 4px;
    cursor: default;
    transition: 0.3s;
    pointer-events: none;
}
@media(max-width: 1430px){
    .flex{
        flex-direction: column;
        max-width: 100%;
    }
    .justify-between{
        justify-content: flex-start;
    }
    .items-center{
        align-items: flex-start;
    }

}
@media screen and (max-width: 550px){
    .custom-modal-class {
        max-height: 80vh;
    }
    .custom-modal-class .custom-field-class >>> .form-row {
        flex-direction: column;
    }
    .custom-modal-class >>> .modal-header  {
        padding: 1rem 0;
    }
    .custom-modal-class >>> .modal-header h2 {
        font-size: 24px;
    }
    .custom-modal-class >>> .custom-inner-wrapper {
        max-width: 100%;
    }
    .custom-field-class >>> input {
        width: 100%;
    }
    .custom-modal-class .form-wrapper {
        width: 100%;
    }
    .custom-modal-class .button-red-smaller,
    .custom-modal-class .button-green-smaller{
        max-width: 100%;
    }
}
</style>
